// extracted by mini-css-extract-plugin
export default {"container":"ReportsPage_container__+EXnu","iframe":"ReportsPage_iframe__mh80X"};